<template>
  <div class="discount_component">
    <transition name="fadeFast" mode="out-in">
      <div class="discount_block"
           :class="{'discount_block__size_medium': !enableTimer}"
           key="block_visible"
           v-if="!modalDiscountIsHidden"
      >
        <transition name="fade">
          <ModalDiscount
            v-if="showModalDiscount"
            @closeModal="closeModalDiscount()"
          ></ModalDiscount>
        </transition>

        <div class="discount_data">
          <div class="discount_timer"
               v-if="enableTimer"
          >
            {{timer.minutesString + ':' + timer.secondsString}}
          </div>

          <div class="discount_title"
               :class="{'discount_title__margin_none': !enableTimer}"
          >{{ titleBlock }}</div>
          <div class="discount_description text text__h5">{{discountData.text}}</div>

          <div class="button button__theme_white"
               @click="getDiscount()"
          >
            <div class="text">
              {{ textButton }}
            </div>
            <div class="svg">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.94141 14.75L12.75 9.5L7.94141 4.25L6.75 5.55077L10.3672 9.5L6.75 13.4492L7.94141 14.75Z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="button button__theme_close"
             v-if="enableChangeVisibility"
             @click="hideModalDiscount()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.2502 5L11.9994 10.25L6.74984 5L5 6.75L10.2495 12L5 17.25L6.74984 19L11.9994 13.75L17.2502 19L19 17.25L13.7505 12L19 6.75L17.2502 5Z" fill="#E2E2F6"/>
          </svg>
        </div>

        <div class="svg svg__theme_background svg__desktop"
             v-html="backgroundSvg"
        ></div>
        <div class="svg svg__theme_background svg__mobile"
             v-html="backgroundSvgMobile"
        ></div>
      </div>

      <div class="block block__theme_hidden-discount"
           key="block_hidden"
           v-else
      >
        <div class="block block__row">
          <div class="svg svg__theme_warning">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9453 2.33301C7.54266 2.33301 2.3335 7.56667 2.3335 13.9997C2.3335 20.4327 7.56716 25.6663 14.0002 25.6663C20.4332 25.6663 25.6668 20.4327 25.6668 13.9997C25.6668 7.56667 20.4087 2.33301 13.9453 2.33301ZM15.1668 19.833H12.8335V17.4997H15.1668V19.833ZM15.1668 15.1663H12.8335V8.16634H15.1668V15.1663Z" fill="#FFCC48"/>
            </svg>
          </div>

          <div class="block block__column block_content">
            <div class="text text__medium">Предложение о скидке было скрыто</div>
            <div class="button button__theme_open block__mobile"
                 @click="visibleModalDiscount()"
            >Показать снова</div>
          </div>
        </div>

        <div class="button button__theme_open block__desktop"
             @click="visibleModalDiscount()"
        >Показать снова</div>
      </div>
    </transition>
  </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import ModalDiscount from "@/components/BuyCourse/PlatformBuyComponents/ModalWindows/ModalDiscount";
import { offerToBuyImage } from '../../../svgStoreFiles.js';

export default {
  name: "OfferToBuyComponent",

  props: {
    discountData: { // данные с информацией о скидке
      type: Object,
      default: () => {
        return {
          isActive: false, // активна ли скидка
          text: '',
          discount: 0, // сумма скидки
          timeEnd: undefined, // время окончания действия скидки
        }
      }
    },

    textButton: { // наименование кнопки
      type: String,
      default: () => {
        return 'Получить скидку'
      }
    },

    enableScroll: { // включить скролл к элементу при клике на кнопку "Получить скидку"
      type: Boolean,
      default: () => {
        return false
      }
    },

    enableTimer: { // включить таймер для обратного отсчета оставшегося времени
      type: Boolean,
      default: () => {
        return true
      }
    },

    enableChangeVisibility: { // включить изменение видимости блока (возможность отобразить / скрыть)
      type: Boolean,
      default: () => {
        return true
      }
    },

    scrollId: { // id для скролинга к требуемому блоку
      type: String,
      default: () => {
        return ''
      }
    },

    buttonRoute: { // маршрут при клике на кнопку получения скидки
      type: Object,
      default: () => {
        return {}
      }
    },

    titleBlock: { // заголовок для блока
      type: String,
      default: () => {
        return 'Следующий предмет со скидкой!'
      }
    },

    keyBlock: { // ключ блока, используется для определения на каких id данный блок скрыт / gkSale - для акции со скидкой на 2-й предмет / ffUpTariff - повышение тарифа для огненного итогового / ffAdditionPay - доплата по тарифу для огненного итогового / pgkUpTariff - повышение тарифа для ПГК / pgkAdditionPay - доплата по тарифу для ПГК
      type: [String, Number],
      default: () => {
        return 'gkSale'
      }
    },

    backgroundSvg: { // изображение для заднего фона
      type: String,
      default: () => {
        return offerToBuyImage.discountGK
      }
    },

    backgroundSvgMobile: { // изображение для заднего фона для мобильных устройств
      type: String,
      default: () => {
        return offerToBuyImage.discountGKMobile
      }
    },
  },

  data() {
    return {
      modalDiscountIsHidden: false, // модальное окно скрыто?
      showModalDiscount: false, // показать модальное окно со скидкой
      timer: {
        minutes: 60,
        seconds: 0,
        minutesString: '60',
        secondsString: '00',
      },
    }
  },

  created() {
    this.modalDiscountIsHidden = this.$store.state.visibleDiscountModal.ids.includes(this.keyBlock);
    if (this.enableTimer) this.startTimer();
  },

  mounted() {

  },

  methods: {
    // получить скидку
    getDiscount() {
      this.$emit('buttonClick', null);
      /*if (this.keyBlock === 'gkSale') { // для скидки по ГК // TODO: разобраться с зависимостями, по необходимости удалить
        if (Object.keys(this.buttonRoute).length > 0) { // если есть роутинг для перехода по кнопке
          this.$router.push(this.buttonRoute);
        } else if (this.enableScroll) {
          let header = document.getElementById('header_component');

          if (header) {
            let heightHeader = header.offsetHeight;
            VueScrollTo.scrollTo('#' + this.scrollId, 500, {offset: -(heightHeader + 20)});
          } else {
            VueScrollTo.scrollTo('#' + this.scrollId, 500, {offset: -20});
          }

        } else {
          this.showModalDiscount = true;
        }
      } else {
        this.$emit('buttonClick', null);
      }*/
    },

    // закрыть модальное окно с данными о скидке
    closeModalDiscount() {
      this.showModalDiscount = false;
    },

    // скрыть модальное окно со скидкой
    hideModalDiscount() {
      this.modalDiscountIsHidden = true;
      let idsHidden = this.$store.state.visibleDiscountModal.ids;

      if (!idsHidden.includes(this.keyBlock)) {
        this.$store.commit('setVisibleDiscountModal', {
          ids: idsHidden.push(this.keyBlock),
        });
      }
    },

    // отобразить модальное окно со скидкой
    visibleModalDiscount() {
      this.modalDiscountIsHidden = false;
      let idsHidden = this.$store.state.visibleDiscountModal.ids;
      let indexIdsHidden = idsHidden.indexOf(this.keyBlock);

      if (indexIdsHidden !== -1) {
        this.$store.commit('setVisibleDiscountModal', {
          ids: idsHidden.splice(indexIdsHidden, 1),
        });
      }
    },

    // возвращает время по москве в секундах
    getMskTime() {
      let mskTime = new Date().toLocaleTimeString('ru-RU', { timeZone: 'Europe/Moscow' });
      let mskDate = new Date().toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' });
      let mskTimeSplit = mskTime.split(':');  // 18:22:33
      let mskDateSplit = mskDate.split('.'); // 23.09.gk

      return Number(new Date( mskDateSplit[2] + '-' + mskDateSplit[1] + '-' +  mskDateSplit[0] + 'T' + mskTimeSplit[0] + ':' + mskTimeSplit[1] + ':' + mskTimeSplit[2] + '+03:00').getTime())/1000;
    },

    // установить текущее время таймера
    setCurrentTimeTimer(timeLeft) {
      this.timer.minutes = Math.floor(timeLeft / 60);
      this.timer.seconds = timeLeft % 60;

      this.timer.minutesString = String(this.timer.minutes);
      this.timer.secondsString = String(this.timer.seconds);

      if (this.timer.minutes < 10) this.timer.minutesString = '0' + this.timer.minutesString;
      if (this.timer.seconds < 10) this.timer.secondsString = '0' + this.timer.secondsString;
    },

    startTimer() {
      let th = this;

      let currentTime = this.getMskTime();
      if (currentTime < this.discountData.timeEnd) {
        this.setCurrentTimeTimer(this.discountData.timeEnd - currentTime);

        let interval = 1000; // ms
        let expected = Date.now() + interval;
        setTimeout(step, interval);
        let step = () => {
          let dt = Date.now() - expected; // the drift (positive for overshooting)
          if (dt > interval) {
            console.log('error function dt > interval')
            console.log('dt = ' + dt)
            console.log('interval = ' + interval)

            th.startTimer();
          } else {

            expected += interval;

            currentTime = th.getMskTime();
            if (currentTime < th.discountData.timeEnd) {
              th.setCurrentTimeTimer(th.discountData.timeEnd - currentTime);
              setTimeout(step, Math.max(0, interval - dt)); // take into account drift
            } else {
              th.setCurrentTimeTimer(0);
              th.$emit('closeComponent');
            }
          }
        }
      } else {
        this.$emit('closeComponent');
      }
    },
  },

  components: {
    ModalDiscount
  }
}
</script>

<style scoped lang="scss">
@import "../../../style/styles_fonts";

$font_Geometria: Geometria, 'Geometria';

$color_background: #F6F6FB;
$color_Gray_1: #C5C5C9;
$color_Gray_2: #ABABB2;
$color_Gray_3: #8D909F;
$color_Gray_4: #EBEBEB;
$color_Gray_5: #6E798C;
$color_Gray_6: #8D909F;
$color_Gray_7: #F9F9F9;
$color_black: #333333;
$color_purple: #8C71FE;
$color_purple_2: #F2F1FF;
$color_purple_3: #E2E2F6;
$color_purple_4: #7B61EB;
$color_purple_5: #6F57D6;
$color_purple_6: #B1A1F2;
$color_red: #FF6597;
$color_green: #89CE54;
$color_grey: #AEBCD6;
$color_cyan: #C0CADC;
$color_cyan_2: #AEBCD6;
$color_cyan_3: #D1DBED;

$transition_medium: 0.5s ease;
$transition_fast: 0.25s ease;

.fadeFast-enter-active, .fadeFast-leave-active {
  transition: opacity .25s;
}
.fadeFast-enter-from, .fadeFast-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.discount_component {
  .block__desktop {
    display: flex;
  }

  .block__mobile {
    display: none;
  }
}

.block__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.block__column {
  display: flex;
  flex-direction: column;
}

.discount_block {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 16px;
  width: calc(100% - 80px);
  padding: 32px 40px;
  background-color: $color_purple;
  position: relative;
  overflow: hidden;

  .svg__desktop {
    display: flex;
  }

  .svg__mobile {
    display: none;
  }
}

.discount_data {
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 340px);
}

.discount_timer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: $color_purple_2;
  color: $color_purple;
  border-radius: 4px;
  height: 25px;
  width: min-content;
  padding: 2px 10px 0 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 19px;
  min-width: calc(63px - 20px);
}

.discount_title {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 120%;
  color: white;
  margin-top: 12px;
}

.discount_component .discount_title__margin_none {
  margin-top: 0;
}

.discount_description {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  margin-top: 6px;
  color: white;
}

.button__theme_close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  svg path {
    transition: $transition_medium;
  }
}

.button__theme_white {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 2px solid #FFFFFF;
  border-radius: 8px;
  height: 47px;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 39px;
  transition: $transition_medium;
  cursor: pointer;
  color: white;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 19px;
  width: fit-content;

  &:hover {
    background-color: white;
    color: $color_purple;

    svg path {
      fill: $color_purple;
    }
  }

  .svg {
    margin-left: 2px;
  }
}

.svg__theme_background {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
}

.svg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.block__theme_hidden-discount {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 26px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  background-color: white;

  .block_content {
    margin-left: 12px;
  }

  .block__mobile {
    display: none;
  }

  .block__desktop {
    display: flex;
  }

  .text__medium {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    color: $color_black;
  }

  .button__theme_open {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    transition: $transition_medium;
    cursor: pointer;
    color: $color_purple;

    &:hover {
      color: $color_purple_4;
    }
  }
}

@media all and (max-width: 1600px) {
  .discount_block {
    width: calc(100% - 76px);
    padding: 30px 38px;
  }

  .block__theme_hidden-discount {
    padding: 16px 22px;

    .svg__theme_warning svg {
      width: 26px;
      height: 26px;
    }

    .block_content {
      margin-left: 10px;
    }

    .text__medium {
      font-size: 14px;
      line-height: 18px;
    }

    .button__theme_open {
      font-size: 14px;
      line-height: 18px;
    }
  }
}

@media all and (max-width: 1440px) {
  .discount_block {
    width: calc(100% - 64px);
    padding: 28px 32px;
    border-radius: 10px;
  }

  .discount_timer {
    height: 23px;
    padding: 1px 8px 0 8px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    min-width: calc(62px - 16px);
  }

  .discount_title {
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 120%;
  }

  .discount_description {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 130%;
    margin-top: 5px;
  }

  .button__theme_white {
    border: 1px solid #FFFFFF;
    border-radius: 6px;
    height: 42px;
    margin-top: 23px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    padding: 0 16px;
  }

  .svg__theme_background {
    display: flex;
    right: -58px;
    bottom: 0;
  }

  .discount_block__size_medium .svg__theme_background {
    right: -20px;
  }

  .discount_data {
    display: flex;
    flex-direction: column;
    max-width: calc(100% - 260px);
  }

  .block__theme_hidden-discount {
    padding: 14px 20px;
    border-radius: 10px;
  }
}

@media all and (max-width: 1280px) {
  .block__theme_hidden-discount {
    padding: 11px 16px;

    .block_content {
      margin-left: 8px;
    }

    .svg__theme_warning svg {
      width: 24px;
      height: 24px;
    }

    .text__medium {
      font-size: 13px;
      line-height: 16px;
    }

    .button__theme_open {
      font-size: 13px;
      line-height: 16px;
    }
  }
}

// tablet
@media all and (max-width: 1160px) {
  .button__theme_white {
    &:hover {
      background-color: rgba(255, 255, 255, 0);
      color: white;

      svg path {
        fill: white;
      }
    }

    .svg {
      margin-left: 2px;
    }
  }

  .discount_data {
    display: flex;
    flex-direction: column;
    max-width: calc(100% - 340px);
  }
}

@media all and (max-width: 960px) {
  .discount_data {
    display: flex;
    flex-direction: column;
    max-width: calc(100% - 280px);
  }
}

// mobile
@media all and (max-width: 600px) {
  .discount_component {
    .block__desktop {
      display: none;
    }

    .block__mobile {
      display: flex;
    }
  }

  .discount_block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(100% - 44px);
    padding: 18px 22px 136px 22px;
    border-radius: 8px;
    margin: 0 auto;

    .svg__desktop {
      display: none;
    }

    .svg__mobile {
      display: flex;
    }
  }

  .discount_data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    width: 100%;
  }

  .svg__theme_background {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    right: auto;
    overflow: hidden;
    position: absolute;
    bottom: 0;
  }

  .discount_title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 120%;
    margin-top: 8px;
    text-align: center;
  }

  .discount_description {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    margin-top: 3px;
    text-align: center;
  }

  .button__theme_white {
    border: 1px solid #FFFFFF;
    border-radius: 6px;
    height: 40px;
    margin-top: 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    padding: 0 16px;
    width: calc(100% - 32px);
    max-width: 250px;
  }

  .button__theme_close svg {
    width: 22px;
    height: 22px;
  }

  .block__theme_hidden-discount {
    padding: 12px 14px;

    .block_content {
      margin-left: 8px;
    }

    .svg__theme_warning svg {
      width: 24px;
      height: 24px;
    }

    .text__medium {
      font-size: 13px;
      line-height: 16px;
    }

    .button__theme_open {
      font-size: 13px;
      line-height: 16px;
      margin-top: 2px;
    }
  }

  .discount_block__size_medium {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 22px 20px 22px;

    .discount_data {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }

    .discount_description {
      margin-top: 5px;
      text-align: start;
    }

    .button__theme_white {
      margin-top: 23px;
      width: auto;
      padding: 0 22px;
    }

    .svg__theme_background {
      right: 22px;
      bottom: 16px;
    }
  }
}
</style>